import { createContext, useContext, useState, useEffect, useCallback } from "react";
import * as stnApi from "@/api/stnApi";

const STNAuthContext = createContext(null);

export const STNAuthProvider = ({ children }) => {
  const [founder,  setFounder]  = useState(null);
  const [startup,  setStartup]  = useState(null);
  const [loading,  setLoading]  = useState(true);

  // On mount — try to restore session from stored token
  useEffect(() => {
    const token = localStorage.getItem("stn-token");
    if (!token) { setLoading(false); return; }

    stnApi.getMe()
      .then(({ founder, startup }) => {
        setFounder(founder);
        setStartup(startup);
      })
      .catch(() => localStorage.removeItem("stn-token"))
      .finally(() => setLoading(false));
  }, []);

  const _store = (token, founder, startup) => {
    localStorage.setItem("stn-token", token);
    setFounder(founder);
    setStartup(startup);
  };

  const register = useCallback(async (body) => {
    const data = await stnApi.register(body);
    _store(data.token, data.founder, data.startup);
    return data;
  }, []);

  const login = useCallback(async (body) => {
    const data = await stnApi.login(body);
    _store(data.token, data.founder, data.startup);
    return data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("stn-token");
    setFounder(null);
    setStartup(null);
  }, []);

  const refreshStartup = useCallback(async () => {
    const data = await stnApi.getMe();
    setFounder(data.founder);
    setStartup(data.startup);
    return data;
  }, []);

  return (
    <STNAuthContext.Provider value={{
      founder, startup, loading,
      isAuthenticated: !!founder,
      register, login, logout, refreshStartup,
      setStartup,
    }}>
      {children}
    </STNAuthContext.Provider>
  );
};

export const useSTNAuth = () => {
  const ctx = useContext(STNAuthContext);
  if (!ctx) throw new Error("useSTNAuth must be used inside STNAuthProvider");
  return ctx;
};
